import React, { useState } from "react"
import { useHistory } from "react-router-dom"
import QuizModal from "./QuizModal"

const Quiz = () => {
  const history = useHistory()
  const [isOpen, setIsOpen] = useState(true)

  // Closing the quiz while nothing is in progress (or once a quiz has been
  // finished) always lands back on the lobby — a fixed destination instead
  // of history.goBack(), which could land somewhere unexpected depending on
  // how the user got here.
  const toggle = () => {
    setIsOpen(false)
    history.push("/page/lobby")
  }

  return <QuizModal isOpen={isOpen} toggle={toggle} />
}

export default Quiz